import { RetailerStoryblok } from "@/generated/sb/sb-types";

export const Retailer = ({}: { retailer: RetailerStoryblok }) => {
  // TODO: verify??
  return null;
  // const retailerEmailLink = retailer.email.url
  //   ? getLink(retailer.email.url)?.href
  //   : undefined;
  // return (
  //   <tr className={styles.wrapper}>
  //     <td>
  //       <h3 className={styles.name}>{retailer.name}</h3>
  //     </td>
  //     <td>{retailer.city}</td>
  //     <td>
  //       <p>
  //         {retailer.address}
  //         <br />
  //         {retailer.zip} {retailer.city}
  //       </p>

  //       {retailer.mapLink && (
  //         <p>
  //           <Link href={retailer.mapLink}>Open in Google Maps</Link>
  //         </p>
  //       )}
  //     </td>
  //     <td>
  //       <div className={styles.links}>
  //         {retailer.openingHours && (
  //           <div className={styles.opening}>
  //             {retailer.openingHours.split("\n").map((str: string, key) => (
  //               <p key={key}>{str}</p>
  //             ))}
  //           </div>
  //         )}
  //         {retailer.phone && <p>Contact: {retailer.phone}</p>}

  //         {retailerEmailLink &&
  //           retailerEmailLink !== "/" &&
  //           retailerEmailLink !== "" && (
  //             <Link href={retailerEmailLink}>Email</Link>
  //           )}
  //       </div>
  //     </td>

  //     {/* <p>{retailer.country}</p> */}
  //   </tr>
  // );
};
